import { render, staticRenderFns } from "./left_or_right_image.vue?vue&type=template&id=1db38018&scoped=true&"
import script from "./left_or_right_image.vue?vue&type=script&lang=js&"
export * from "./left_or_right_image.vue?vue&type=script&lang=js&"
import style0 from "./left_or_right_image.vue?vue&type=style&index=0&id=1db38018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db38018",
  null
  
)

export default component.exports